export default "__VITE_ASSET__DjxS$JCD__"